(function ($) {
    var counter = 0;
    var defaultAttrName = 'mdbstamp';
    /*  generates a unique attribute for each element */
    $.fn.stamp = function (attrName) {
        if (!attrName) attrName = defaultAttrName;
        return this.each(function() {
            var me = $(this);
            if (!me.attr(attrName)) {
                counter++;
                me.attr(attrName, '' + counter);
            }
        });
    };
})(jQuery);